module.exports = __webpack_public_path__ + "static/media/student6.1e874ac7.svg";